import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Local } from 'protractor/built/driverProviders';
import * as ngswal from "sweetalert";
import { ApiMethod } from '../apimethods/api-method';
import { customfunctions, DataParam } from '../common/customfunctions';
import { GlobalConstants } from '../common/global-constants';
import { UtilityProcesseModel } from './utility-processmodel';
import tableDragger from 'table-dragger';
declare var $;

@Component({
  selector: 'app-utility-process',
  templateUrl: './utility-process.component.html',
  styleUrls: ['./utility-process.component.css']
})
export class UtilityProcessComponent implements OnInit {
  modelItem = new UtilityProcesseModel();

  // data table UtilityProcessMaster
  @ViewChild('dataTable', { static: false }) table: { nativeElement: any; }
  dataSet: string;
  dataTable: any;
  // Utility Process Publisher Mapping
  @ViewChild('dataTablePM', { static: false }) tablePM: { nativeElement: any; }
  dataSetPM: string;
  dataTablePM: any;

  showpopup: boolean;
  UPMpopUpButtonText: string;
  showpopupUtilityProcessMaster: boolean;
  UPMTitle: string;
  showpopupUtilityProcessPublisherMapping: boolean;
  UPPMpopUpButtonText: string;
  UPPMTitle: string;
  PublisherList: any;
  ManuflowProductType: any;
  ManuflowPublisherType: any;
  VendorList: any;
  ArticleTypes: any;
  JournalsList: any;
  UtilityProcessMasterList: any;
  aUPPMTransList: any;
  showpopupUPPMTrans: boolean;
  UPPMTransTitle: string;
  UPPMTranspopUpButtonText: string;
  PlFileNameList: any;

  constructor(private router: Router, private route: ActivatedRoute) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <UtilityProcesseModel>data["UtilityProcessePage"];

        $('#ddl_Process').select2({
          placeholder: "Select Process",
          dropdownParent: "#UPPMpopup",
          allowClear: true
        });
        $('#ddl_Vendor').select2({
          placeholder: "Select Vendor",
          dropdownParent: "#UPPMpopup",
          allowClear: true
        });

        $('#ddl_PublisherType').select2({
          placeholder: "Select PublisherType",
          dropdownParent: "#UPPMpopup",
          allowClear: true
        });

        $('#ddl_ProductType').select2({
          placeholder: "Select ProductType",
          dropdownParent: "#UPPMpopup",
          allowClear: true
        });

        $('#ddl_Journals').select2({
          placeholder: "Select Journals",
          dropdownParent: "#UPPMpopup",
          allowClear: true
        });

        $('#ddl_ArticleTypes').select2({
          placeholder: "Select ArticleTypes",
          allowClear: true,
          dropdownParent: "#UPPMpopup"
        });

        $('#ddl_PlFileName').select2({
          placeholder: "Select PlFileName",
          allowClear: true, tags: true,
          dropdownParent: "#UPPMTransPopup"
        });


        localStorage.UPPMTransID = 0;
        this.GetDropdownlists();
        this.GetUtilityProcessMasterdata();
        this.GetUtilityProcessPublisherMappingdata();

      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }
  constructormethods() {
    this.GetDropdownlists();
    this.GetUtilityProcessMasterdata();
    this.GetUtilityProcessPublisherMappingdata();
  }

  ngOnInit(): void {
    ApiMethod.getBaseUrl();
  }

  //Get Dropdown lists
  GetDropdownlists(): void {
    $("#LoadingImage").show();

    ApiMethod.getMethod(this.modelItem.GetDropdownlists + "/" + localStorage.aPubID).subscribe(
      result => {
        this.PublisherList = result.aPublisherList;
        this.ManuflowProductType = result.aManuflowProductType;
        this.ManuflowPublisherType = result.aManuflowPublisherType;
        this.VendorList = result.aVendorList;
        this.ArticleTypes = result.aArticleTypes;
        this.JournalsList = result.aJournalsList;
        this.UtilityProcessMasterList = result.aUtilityProcessMasterList;
        this.PlFileNameList = result.aPlFileNameList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      }
    );
  }


  /* ---------------------- UtilityProcess Master------------------------*/

  //Get UtilityProcess Master data Table
  GetUtilityProcessMasterdata() {
    $("#LoadingImage").show();
    var dataitem = {
      PublisherId: localStorage.aPubID,
      LoginId: localStorage.aLoginID,
    };
    ApiMethod.postMethod(this.modelItem.GetUtilityProcessMasterdata, dataitem).subscribe(
      Response => {
        this.dataSet = JSON.stringify(Response.aitemList);
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let aColList = Response.acolListL;
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 210);
        dataItem.modulename = 'UtilityProcessMasterModule';
        dataItem.aNewButtonName = 'BtnPopup';
        dataItem.isDefault = false;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  //Hide UtilityProcess Master Popup
  UPMhide() {
    this.showpopupUtilityProcessMaster = false;
    localStorage.aEID = 0;
  }

  // clear UtilityProcess Master Popup fields
  UPMClear() {
    $('#Txt_ProcessName').val("");
    $('#Txt_ProcessFlow').val("");
    $('#Txt_Remakrs').val("");
    $("#Chk_UPMIsDelete").prop('checked', false);
  }
  //Show UtilityProcess Master
  ShowUtilityProcessMaster() {
    $("#LoadingImage").show();
    this.showpopupUtilityProcessMaster = true;
    this.UPMClear();
    if (localStorage.aEID != 0) {
      $(".Chk_UPMIsDelete").show();
      ApiMethod.getMethod(this.modelItem.ShowUtilityProcessMasterAPI + "/" + localStorage.aEID).subscribe(
        result => {
          var aitems = result.aUtilityProcessMasterByID;
          $('#Txt_ProcessName').val(aitems[0].ProcessName);
          $('#Txt_ProcessFlow').val(aitems[0].ProcessFlow);
          $('#Txt_Remakrs').val(aitems[0].Remakrs);

          this.UPMTitle = `Process Master : ${aitems[0].ProcessName} `;
        }, error => {
          $("#LoadingImage").hide();
          ngswal("Warning !", error, "warning");
        }
      );
      this.UPMpopUpButtonText = "Update";
    } else {
      $(".Chk_UPMIsDelete").hide();
      this.UPMpopUpButtonText = "Add";
      this.UPMTitle = "Add Process Master";
    }
    $("#LoadingImage").hide();
  }

  //Update UtilityProcess Master
  UpdateUtilityProcessMaster() {
    //Validation 
    if ($('#Txt_ProcessName').val().trim() == '') {
      $('#Txt_ReleasePeriod').focus();
      ngswal("Warning !", "Enter Process name!", "warning");
    }
    else if ($('#Txt_ProcessFlow').val().trim() == '') {
      $('#Txt_ReleasePeriod').focus();
      ngswal("Warning !", "Enter Process flow!", "warning");
    }
    else {
      $("#LoadingImagePopup").show();
      var dataparam = {
        Id: localStorage.aEID,
        UpdatedBy: localStorage.aLoginID,
        ProcessName: $('#Txt_ProcessName').val(),
        ProcessFlow: $('#Txt_ProcessFlow').val(),
        Remakrs: $('#Txt_Remakrs').val(),
        IsDeleted: $("#Chk_UPMIsDelete").prop('checked') ? 1 : 0
      };
      console.log(dataparam);
      ApiMethod.postMethod(this.modelItem.UpdateUtilityProcessMasterAPI, dataparam).subscribe(
        response => {
          if (response.status) {

            this.constructormethods();
            this.UPMhide();
            ngswal("Success !", response.message, "success");
          } else {
            ngswal("Failed !", response.message, "warning");
          }
          $("#LoadingImagePopup").hide();
        },
        error => {
          ngswal("Failed !", error.Message, "warning");
          $("#LoadingImagePopup").hide();
        }
      );
    }
  }

  UPMIsDeleteConfirmation(event: any) {
    const isChecked = event.target.checked;
    if (isChecked) {
      ngswal({
        title: "Delete Confirmation",
        text: "Are you sure Delete Process Master details?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        closeOnConfirm: true,
        closeOnCancel: true
      },
        function (isConfirm) {

          if (isConfirm) {
            return true;
          } else {
            $("#Chk_UPMIsDelete").prop('checked', false);
            return false;
          }
        });
    }
  }

  /* ------------------------------ UtilityProcess Master end ------------------------*/
  /* ------------------------------ UtilityProcess Publisher Mapping (UPPM)------------------------*/

  //Get UtilityProcess Publisher Mapping data Table
  GetUtilityProcessPublisherMappingdata() {
    $("#LoadingImage").show();
    var dataitem = {
      PublisherId: localStorage.aPubID,
      LoginId: localStorage.aLoginID,
    };
    ApiMethod.postMethod(this.modelItem.GetUtilityProcessPublisherMappingdata, dataitem).subscribe(
      Response => {
        console.log(Response.aitemList);
        console.log(Response.acolListL);
        this.dataSetPM = JSON.stringify(Response.aitemList);
        this.dataSetPM = JSON.parse(this.dataSetPM);
        this.dataTablePM = $(this.tablePM.nativeElement);

        //Dynamic datable
        let aColList = Response.acolListL;
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTablePM;
        dataItem.dataset = this.dataSetPM;
        dataItem.dtheight = (GlobalConstants.size.height - 210);
        dataItem.modulename = 'UtilityProcessPublisherMappingModule';
        dataItem.aNewButtonName = 'Btnpopup';
        dataItem.isDefault = false;
        this.dataTablePM = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImageReopen").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  //Dragable table row
  tabledrag(): void {
    var el = document.getElementById('tblUPPMtans');
    var dragger = tableDragger(el, {
      mode: 'row',
      dragHandler: '',
      onlyBody: true,
      animation: 500
    });
    dragger.on('drop', function (from, to) {
      $("table#tblUPPMtans tbody").each(function (ind) {
        $(this).children().each(function (index) {
          $(this).find('td').eq(0).html((index + 1).toString());
        });
      });
    });
  }
  callUPPMTLastRow() {
    if ($('.sindu_handle').length == 0)
      this.tabledrag();
  }

  //Show UtilityProcess Publisher Mapping popup
  UPPMhide() {
    this.showpopupUtilityProcessPublisherMapping = false;
    localStorage.aEID = 0;
  }

  //clear UtilityProcess Publisher Mapping popup details
  UPPMClear() {
    $('#Txt_UtilityConfigName').val("");
    $('#Txt_UPPMRemarks').val("");
    $('#ddl_Process').val(0).change();
    $('#ddl_Vendor').val(0).change();
    $('#ddl_PublisherType').val(0).change();
    $('#ddl_ProductType').val(0).change();
    $('#ddl_Journals').val(0).change();
    $('#ddl_ArticleTypes').val(0).change();
    $("#Chk_UPPMIsDelete").prop('checked', false);
    $("#tblUPPMtans tbody").html("");
  }

  //Show UtilityProcess Publisher Mapping Trans
  ShowUtilityProcessMasterTrans() {
    this.showpopupUtilityProcessPublisherMapping = true;
    $("#LoadingImagePopup1").show();
    this.UPPMClear();
    if (localStorage.aEID != 0) {
      $(".Chk_UPPMIsDelete").show();
      ApiMethod.getMethod(this.modelItem.ShowUtilityProcessPubMasterAPI + "/" + localStorage.aEID).subscribe(
        result => {
          var aitems = result.aUPPMDetailsByID;
          var aUPPMTransList = result.aUPPMTransDetailsByID;

          console.log(aUPPMTransList);
          $('#Txt_UtilityConfigName').val(aitems[0].UtilityConfigName);
          $('#Txt_UPPMRemarks').val(aitems[0].Remarks);
          $('#ddl_Process').val(aitems[0].ProcessId).change();
          $('#ddl_Vendor').val(aitems[0].VendorId).change();
          $('#ddl_PublisherType').val(aitems[0].PublisherTypeId).change();
          $('#ddl_ProductType').val(aitems[0].ProductTypeId).change();
          $('#ddl_Journals').val(aitems[0].JournalId).change();
          $('#ddl_ArticleTypes').val(aitems[0].ArticleTypeId).change();

          //Xml Path Details Table 
          $("#tblUPPMtans tbody").html("");
          if (aUPPMTransList.length != 0) {
            var nRowR = "";
            for (var i = 0; i < aUPPMTransList.length; i++) {
              nRowR += "<tr id='tr" + (i + 1).toString() + "'>";
              nRowR += "<td for='SequenceNo'>" + GlobalConstants.isNullCheck(aUPPMTransList[i].SequenceNo) + "</td>";
              nRowR += "<td for='Id'style='display:none;'>" + GlobalConstants.isNullCheck(aUPPMTransList[i].Id) + "</td>";
              nRowR += "<td for='ProcessMappingId' style='display:none;'>" + GlobalConstants.isNullCheck(aUPPMTransList[i].ProcessMappingId) + "</td>";
              nRowR += "<td for='DisplayName'>" + GlobalConstants.isNullCheck(aUPPMTransList[i].DisplayName) + "</td>";
              nRowR += "<td for='Pl_FilePath' style='display:none;'>" + GlobalConstants.isNullCheck(aUPPMTransList[i].Pl_FilePath) + "</td>";
              nRowR += "<td for='InPath' style='display:none;'>" + GlobalConstants.isNullCheck(aUPPMTransList[i].InPath) + "</td>";
              nRowR += "<td for='OutPath' style='display:none;'>" + GlobalConstants.isNullCheck(aUPPMTransList[i].OutPath) + "</td>";
              nRowR += "<td for='ParameterList' style='display:none;'>" + GlobalConstants.isNullCheck(aUPPMTransList[i].ParameterList) + "</td>";
              nRowR += "<td for='Pl_FileName'>" + GlobalConstants.isNullCheck(aUPPMTransList[i].Pl_FileName) + "</td>";
              nRowR += "<td for='IsUpload'  style='display:none;'>" + GlobalConstants.isNullCheck(aUPPMTransList[i].IsUpload) + "</td>";
              nRowR += "<td for='IsDownload'  style='display:none;'>" + GlobalConstants.isNullCheck(aUPPMTransList[i].IsDownload) + "</td>";
              nRowR += "<td for='IsDeleted'  style='display:none;'>" + GlobalConstants.isNullCheck(aUPPMTransList[i].IsDeleted) + "</td>";
              nRowR += "<td for='Action'  style='text-align: center;width:10%'>"
                + "<i class='bx bxs-edit-alt' style='color: #34c38f; font-size: 20px;cursor:Pointer;'  onclick=localStorage.UPPMTransID='" + (i + 1).toString() + "';$('#btnUPPMTAddUpdate').trigger('click');></i>&nbsp;"
                + "</td>";
              nRowR += "</tr>";
            }
            $("#tblUPPMtans tbody").append(nRowR);
            this.callUPPMTLastRow();
          }
          this.UPPMTitle = `Utility Process Mapping : ${aitems[0].UtilityConfigName} `;
        }, error => {
          $("#LoadingImagePopup1").hide();
          ngswal("Warning !", error, "warning");
        }
      );
      this.UPPMpopUpButtonText = "Update";
    } else {
      $(".Chk_UPPMIsDelete").hide();
      this.UPPMpopUpButtonText = "Add";
      this.UPPMTitle = "Add Utility Process Mapping";
    }
    $("#LoadingImagePopup1").hide();
  }

  //Delete confirmation UtilityProcess Publisher Mapping
  UPPMIsDeleteConfirmation(event: any) {
    const isChecked = event.target.checked;
    if (isChecked) {
      ngswal({
        title: "Delete Confirmation",
        text: "Are you sure Delete Utility Process Mapping details?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        closeOnConfirm: true,
        closeOnCancel: true
      },
        function (isConfirm) {

          if (isConfirm) {
            return true;
          } else {
            $("#Chk_UPPMIsDelete").prop('checked', false);
            return false;
          }
        });
    }
  }
 
  //Delete confirmation UtilityProcess Publisher Mapping Trans
  UPPMTIsDeleteConfirmation(event: any) {
    const isChecked = event.target.checked;
    if (isChecked) {
      var rowCount = $('#tblUPPMtans tbody tr').length;
      if (rowCount <= 1) {
        $("#Chk_UPPMTIsDelete").prop('checked', false);
        ngswal("Warning !", "Delete Utility not allowed Please Maintain One Record !", "warning");
        return false;
      }
      ngswal({
        title: "Delete Confirmation",
        text: "Are you sure Delete Utility details?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        closeOnConfirm: true,
        closeOnCancel: true
      },
        function (isConfirm) {

          if (isConfirm) {
            return true;
          } else {
            $("#Chk_UPPMTIsDelete").prop('checked', false);
            return false;
          }
        });
    }
  }

  //show UtilityProcess Publisher Mapping Trans
  ShowUPPMTrans() {
    $("#LoadingImagePopup1").show();

    this.showpopupUPPMTrans = true;
    this.UPPMTransClear();
    if (localStorage.UPPMTransID != 0) {
      $(".Chk_UPPMTIsDelete").show();
      let trId = '#tr' + localStorage.UPPMTransID;
      $("#Txt_Sequence").val($(trId).find('td')[0].innerHTML);
      $("#Txt_DisplayName").val($(trId).find('td')[3].innerHTML);
      $("#Txt_PlFilePath").val($(trId).find('td')[4].innerHTML);
      $("#Txt_InPath").val($(trId).find('td')[5].innerHTML);
      $("#Txt_OutPath").val($(trId).find('td')[6].innerHTML);
      $("#Txt_ParameterList").val($(trId).find('td')[7].innerHTML);
      $("#ddl_PlFileName").val($(trId).find('td')[8].innerHTML).change();

      var IsUpload = $(trId).find('td')[9].innerHTML;
      if (IsUpload == "true") {
        $('#Chk_IsUpload').prop("checked", true);
      } else {
        $('#Chk_IsUpload').prop("checked", false);
      }
      var IsDownload = $(trId).find('td')[10].innerHTML;
      if (IsDownload == "true") {
        $('#Chk_IsDownload').prop("checked", true);
      } else {
        $('#Chk_IsDownload').prop("checked", false);
      }
      var IsDownload = $(trId).find('td')[11].innerHTML;
      if (IsDownload == "1") {
        $('#Chk_UPPMTIsDelete').prop("checked", true);
      } else {
        $('#Chk_UPPMTIsDelete').prop("checked", false);
      }
      this.UPPMTransTitle = "Update Utility";
      this.UPPMTranspopUpButtonText = "Update";
    } else {
      $(".Chk_UPPMTIsDelete").hide();
      var lastsequencValue = $("table#tblUPPMtans tbody tr:last-child td:nth-child(1)").html();
      if (lastsequencValue === undefined || lastsequencValue == null) {
        lastsequencValue = 1;
      } else {
        lastsequencValue++;
      }
      $("#Txt_Sequence").val(lastsequencValue);
      this.UPPMTransTitle = "Add Utility";
      this.UPPMTranspopUpButtonText = "Add";
    }
    $("#LoadingImagePopup1").hide();
  }

  //PlFile Name validation
  PlFilenamevalidation() {
    var fileName = $('#ddl_PlFileName').val() as string; // Ensure fileName is treated as a string
    if (!fileName || fileName.trim() === "") { // Check if fileName is null, undefined, or empty after trimming
      return false;
    }

    fileName = fileName.trim();
    const isValid: boolean = /^[a-zA-Z0-9_-]+\.(pl|exe)$/.test(fileName); // Adjusted regex to allow ".pl" or ".exe" extensions
    if (isValid) {
      return;
    } else {
      $("#ddl_PlFileName").val(0).change();
      ngswal("Warning !", "change Utility File name ends with '.pl' or '.exe'", "warning");
    }
  }


  //Clear UtilityProcess Publisher Mapping Trans
  UPPMTransClear() {
    $('#Txt_Sequence').val("");
    $('#Txt_InPath').val("");
    $('#Txt_OutPath').val("");
    $('#Txt_PlFilePath').val("");
    $('#Txt_ParameterList').val("");
    $('#Txt_ParameterList').val("");
    $('#Txt_DisplayName').val("");
    $('#ddl_PlFileName').val(0).change();
    $('#Chk_IsUpload').prop("checked", false);
    $('#Chk_IsDownload').prop("checked", false);
    $("#Chk_UPPMTIsDelete").prop('checked', false);
  }

  //Clear UtilityProcess Publisher Mapping Trans popup
  UPPMTranshide() {
    this.showpopupUPPMTrans = false;
    localStorage.UPPMTransID = 0;
  }

  // Add/Update UtilityProcess Publisher Mapping Trans
  AddUpdateUPPMTrans() {
    if ($('#ddl_PlFileName').val() == null) {
      ngswal("Warning !", "Enter Utility FileName!", "warning");
    } else if ($('#Txt_DisplayName').val() == '') {
      ngswal("Warning !", "Enter DisplayName!", "warning");
    } else {
      $("#LoadingImagePopup2").show();
      var UPPMTIsDelete = $("#Chk_UPPMTIsDelete").prop('checked') ? 1 : 0;
      if (localStorage.UPPMTransID == 0) {
        var zRowLength = $("#tblUPPMtans").find("tr").length;
        var ProcessMID = localStorage.aEID;
        $("#tblUPPMtans tbody").append(
          "<tr id='tr" + zRowLength.toString() + "'>" +
          "<td>" + $("#Txt_Sequence").val() + "</td>" +
          "<td style='display:none;'></td>" +
          "<td style='display:none;'>" + ProcessMID + "</td>" +
          "<td>" + $("#Txt_DisplayName").val() + "</td>" +
          "<td style='display:none;'>" + $("#Txt_PlFilePath").val() + "</td>" +
          "<td style='display:none;'>" + $("#Txt_InPath").val() + "</td>" +
          "<td style='display:none;'>" + $("#Txt_OutPath").val() + "</td>" +
          "<td style='display:none;'>" + $("#Txt_ParameterList").val() + "</td>" +
          "<td>" + $('#ddl_PlFileName option:selected').text().trim() + "</td>" +
          "<td style='display:none;'>" + $("#Chk_IsUpload").prop('checked') + "</td>" +
          "<td style='display:none;'>" + $("#Chk_IsDownload").prop('checked') + "</td>" +
          "<td style='display:none;'>" + UPPMTIsDelete + "</td>" +
          "<td style='text-align: center'>"
          + "<i class='bx bxs-edit-alt' style='color: #34c38f; font-size: 20px;cursor:Pointer;' onclick=localStorage.UPPMTransID='" + zRowLength.toString() + "';$('#btnUPPMTAddUpdate').trigger('click');></i>&nbsp;"
          + "</tr>"
        );
        if (localStorage.aEID != 0) {
          this.UpdateUtilityProcessPubMapping();
        }
        this.UPPMTransClear();
        this.UPPMTranshide();
      } else {

        let trId = "#tr" + localStorage.UPPMTransID;
        $(trId).find("td")[0].outerHTML = "<td>" + $("#Txt_Sequence").val() + "</td>";
        $(trId).find("td")[3].outerHTML = "<td>" + $("#Txt_DisplayName").val() + "</td>";
        $(trId).find("td")[4].outerHTML = "<td style='display:none;'>" + $("#Txt_PlFilePath").val() + "</td>";
        $(trId).find('td')[5].outerHTML = "<td style='display:none;'>" + $("#Txt_InPath").val() + "</td>";
        $(trId).find("td")[6].outerHTML = "<td style='display:none;'>" + $("#Txt_OutPath").val() + "</td>";
        $(trId).find("td")[7].outerHTML = "<td style='display:none;'>" + $("#Txt_ParameterList").val() + "</td>";
        $(trId).find("td")[8].outerHTML = "<td>" + $('#ddl_PlFileName option:selected').text().trim() + "</td>";
        $(trId).find("td")[9].outerHTML = "<td style='display:none;'>" + $("#Chk_IsUpload").prop('checked') + "</td>";
        $(trId).find("td")[10].outerHTML = "<td style='display:none;'>" + $("#Chk_IsDownload").prop('checked') + "</td>";
        $(trId).find("td")[11].outerHTML = "<td style='display:none;'>" + UPPMTIsDelete + "</td>";

        this.UPPMTransClear();
        this.UPPMTranshide();
      }
      $("#LoadingImagePopup2").hide();
    }
  }

  // Update UtilityProcess Publisher Mapping and Trans
  UpdateUtilityProcessPubMapping() {
    if ($('#Txt_UtilityConfigName').val().trim() == '') {
      $('#Txt_UtilityConfigName').focus();
      ngswal("Warning !", "Enter Utility Config Name!", "warning");
    }
    else if ($('#ddl_Process').val() == null) {
      $('#ddl_Process').focus();
      ngswal("Warning !", "Select Process!", "warning");
    }
    else if ($('#ddl_PublisherType').val() == null) {
      $('#ddl_PublisherType').focus();
      ngswal("Warning !", "Select Publisher type!", "warning");
    }
    else if ($('#ddl_ProductType').val() == null) {
      $('#ddl_ProductType').focus();
      ngswal("Warning !", "Select Product type!", "warning");
    } else if ($("#tblUPPMtans tbody tr").html() == null || $("#tblUPPMtans tbody tr").html() == "") {
      $('#tblUPPMtans').focus();
      ngswal("Warning !", "Add Utility !", "warning");
    }
    else {
      $("#LoadingImagePopup1").show();
      var getUPPMTransList = [];
      getUPPMTransList = GlobalConstants.GetTableRowToList('tblUPPMtans', null, true);
      for (var i = 0; i < getUPPMTransList.length; i++) {
        getUPPMTransList[i] = getUPPMTransList[i].toString();
      }
      var dataparam = {
        Id: localStorage.aEID,
        UpdatedBy: localStorage.aLoginID,
        PublisherId: localStorage.aPubID,
        UtilityConfigName: $('#Txt_UtilityConfigName').val(),
        ProcessId: $('#ddl_Process').val(),
        VendorId: $('#ddl_Vendor').val(),
        PublisherTypeId: $('#ddl_PublisherType').val(),
        ProductTypeId: $('#ddl_ProductType').val(),
        JournalId: $('#ddl_Journals').val(),
        ArticleTypeId: $('#ddl_ArticleTypes').val(),
        Remarks: $('#Txt_UPPMRemarks').val(),
        UPPMTransList: getUPPMTransList,
        IsDeleted: $("#Chk_UPPMIsDelete").prop('checked') ? 1 : 0
      };
      ApiMethod.postMethod(this.modelItem.UpdateUtilityProcessPubMappingAPI, dataparam).subscribe(
        response => {
          if (response.status) {
            this.constructormethods();
            if (response.aEID == "0") {
              this.showpopupUtilityProcessPublisherMapping = false;
            } else {
              localStorage.aEID = response.aEID;
              this.ShowUtilityProcessMasterTrans();
            }


            ngswal("Success !", response.message, "success");
          } else {
            ngswal("Failed !", response.message, "warning");
          }
          $("#LoadingImagePopup1").hide();
        },
        error => {
          ngswal("Failed !", error.Message, "warning");
          $("#LoadingImagePopup1").hide();
        }
      );
    }
  }

  /* ---------------------- UtilityProcess Publisher Mapping end ------------------------*/

}

